// src/components/SalePopup.js
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiX, FiTag } from 'react-icons/fi';

const SESSION_KEY = 'cs_sale_popup_seen';

function SalePopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(SESSION_KEY)) {
      setVisible(true);
    }
  }, []);

  function dismiss() {
    sessionStorage.setItem(SESSION_KEY, '1');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="sale-popup-overlay" onClick={dismiss}>
      <div className="sale-popup-dialog" onClick={e => e.stopPropagation()}>

        <button className="sale-popup-close" onClick={dismiss} aria-label="Close">
          <FiX size={18} />
        </button>

        <div className="sale-popup-badge">
          <FiTag size={14} />
          <span>Limited-Time Offer</span>
        </div>

        <h2 className="sale-popup-title">We're Building Our Portfolio</h2>

        <p className="sale-popup-body">
          To grow our portfolio to <strong>10 sites</strong>, we're offering our
          first <strong>10 clients</strong> an exclusive deal — pay a one-time
          <strong> $20 flat fee</strong> to get your site built, then just your
          monthly subscription. No large upfront cost.
        </p>

        <div className="sale-popup-conditions">
          <p className="sale-popup-conditions-title">To qualify, we need at least 3 of each site type:</p>
          <ul className="sale-popup-list">
            <li><span className="sale-popup-dot" style={{ background: '#2dd4bf' }} />Landing Page</li>
            <li><span className="sale-popup-dot" style={{ background: '#818cf8' }} />Standard Website</li>
            <li><span className="sale-popup-dot" style={{ background: '#f59e0b' }} />Premium Website</li>
          </ul>
        </div>

        <p className="sale-popup-cta-text">
          Spots are filling up. Find out what's still available by reaching out directly.
        </p>

        <Link to="/contact" className="sale-popup-btn" onClick={dismiss}>
          Contact Us to Claim Your Spot
        </Link>

      </div>
    </div>
  );
}

export default SalePopup;
